import { render } from "./admin-box.vue?vue&type=template&id=0b664efb&scoped=true"
import script from "./admin-box.vue?vue&type=script&lang=js"
export * from "./admin-box.vue?vue&type=script&lang=js"

import "./admin-box.vue?vue&type=style&index=0&id=0b664efb&lang=stylus&scoped=true"

import exportComponent from "/var/www/docker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b664efb"],['__file',"src/components/admin-dashboard/ui/admin-box.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0b664efb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0b664efb', __exports__)) {
    api.reload('0b664efb', __exports__)
  }
  
  module.hot.accept("./admin-box.vue?vue&type=template&id=0b664efb&scoped=true", () => {
    api.rerender('0b664efb', render)
  })

}


export default __exports__